<script setup>
const props = defineProps(['monthsDates', 'selectedMonth', 'selectedYear']);
defineEmits(['change']);

function getStatusLabel(monthDate) {
  switch (monthDate) {
    case 'AVAILABLE':
      return '';
    case 'UNAVAILABLE':
      return 'Disponibilità terminata';
    case 'FUTURE_POSSIBLE':
      return 'Non ancora prenotabile';
    case 'FUTURE_IMPOSSIBLE':
      return 'Prenotazione non disponibile';
    case 'PRESENT':
      return 'Non disponibile per la data odierna';
    default:
      return '';
  }
}

function getMonthLabel(month) {
  const m = month.toLocaleString('default', { month: 'long' });
  const y = month.toLocaleString('default', { year: 'numeric' });
  return m.charAt(0).toUpperCase() + m.slice(1) + ' ' + y;
}

</script>
<template>
  <div class="select-wrapper mt-5">
    <label for="selectMonth">Seleziona un mese</label>
    <select id="selectMonth" :value="props.selectedYear + '-' + props.selectedMonth + '-' + 1" @change="e => { $emit('change', e.target.value) }">
      <option disabled selected value="">Seleziona un mese</option>
      <option v-for="monthDate in props.monthsDates.filter((item) => item.status !== 'EMPTY')" :key="monthDate" :value="monthDate.date.getFullYear() + '-' + (monthDate.date.getMonth()) + '-' + 1">
        {{ getMonthLabel(monthDate.date) }}
        <span v-if="monthDate.status !== 'AVAILABLE'">- {{ getStatusLabel(monthDate.status) }}</span>
      </option>
    </select>
  </div>
</template>
